import { FetchStatus } from '@server/fetch_status.type';
import { OrgType } from '../../apis/facades/types/crmOrgsApiFacade.types';
import type { CrmOrg } from '../../types/CrmOrgs';

export const shouldReconnectEnv = (crmOrg: CrmOrg) => {
  if (crmOrg.orgType === OrgType.Workato) {
    return false;
  }
  return (
    (crmOrg.fetchStatus === FetchStatus.Error && crmOrg.lastFetchedAt === null) ||
    crmOrg.fetchStatus === FetchStatus.InvalidCredentials
  );
};
